import { useEffect, useRef } from 'react';
import { coachingStyles } from '../../../mocks/landingData';

export default function CoachingStylesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="coaching-styles" ref={sectionRef} className="relative py-20 md:py-28 bg-warm-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-dark-bronze/30 bg-dark-bronze/10 mb-6">
              <i className="ri-user-star-line text-dark-bronze text-sm" />
              <span className="text-dark-bronze text-sm font-medium">Coaching Styles</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-midnight mb-6">
              Choose the coach style you need{' '}
              <span className="gold-gradient-text">in the moment.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {coachingStyles.map((style, index) => (
              <div
                key={index}
                className="animate-on-scroll opacity-0 group relative p-6 rounded-xl bg-midnight border border-royal-navy/30 hover:border-champagne-gold/40 transition-all duration-300 card-hover overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-champagne-gold/5 rounded-full blur-2xl transform translate-x-8 -translate-y-8" />
                <div className="relative z-10">
                  <div className="w-12 h-12 rounded-xl gold-gradient flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${style.icon} text-midnight text-xl`} />
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-warm-white mb-2">{style.title}</h3>
                  <p className="text-silver-grey text-sm leading-relaxed">{style.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}